(function () {
  let observer = null;
  let scheduled = false;

  function sortGrid() {
    const grid = document.querySelector(".product-list__inner");
    if (!grid) return;

    // Flyt kun produktkort (ikke content blocks)
    const items = Array.from(grid.querySelectorAll("product-item.product-item"));
    if (!items.length) return;

    // Stop observer midlertidigt for at undgå loop
    if (observer) observer.disconnect();

    const outOfStock = items.filter((el) => el.dataset.available === "false");
    const inStock = items.filter((el) => el.dataset.available !== "false");

    const newOrder = inStock.concat(outOfStock);

    // Flyt kun hvis rækkefølgen faktisk ændrer sig
    let changed = false;
    for (let i = 0; i < items.length; i++) {
      if (items[i] !== newOrder[i]) {
        changed = true;
        break;
      }
    }

    if (changed) {
      newOrder.forEach((el) => grid.appendChild(el));
    }

    // Genstart observer efter sortering
    const facetMain = document.querySelector("#facet-main");
    if (facetMain) {
      observer = new MutationObserver(() => schedule());
      observer.observe(facetMain, { childList: true, subtree: true });
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      sortGrid();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    schedule();

    const facetMain = document.querySelector("#facet-main");
    if (facetMain) {
      observer = new MutationObserver(() => schedule());
      observer.observe(facetMain, { childList: true, subtree: true });
    }
  });
})();